function testOpenCell(cell, stack, device_id, stack_inner_id = null) {
    let url = "/device/controller/test/open/cell/";

    $.ajax({
        type: "POST",
        url: url,
        data: {
            "csrfmiddlewaretoken": $("input[name='csrfmiddlewaretoken']").prop("value"),
            "cell": cell,
            "stack": stack,
            "device_id": device_id,
            "inner_id": stack_inner_id
        },
        success: function (response) {
            let title = response.title;
            let message = response.message;
            $("#modal-header").text(title).attr("style", "color: green; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: green; text-align: center;");
            $('#message').modal("show");

            setTimeout(function () {
                $('#message').modal("hide");
            }, 2000);
        },
        error: function (response) {
            let title = response.responseJSON.title;
            let message = response.responseJSON.message;
            $("#modal-header").text(title).attr("style", "color: red; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: red; text-align: center;");
            $('#message').modal("show");

            setTimeout(function () {
                $('#message').modal("hide");
            }, 2000);
        }
    })
}

function saveDeviceMappingForm(device_uid) {
    let url = "/device/" + device_uid + "/mapping/";

    let stacks = document.getElementsByName("stack_number");
    let serials = document.getElementsByName("controller_serial");

    let _stacks = [];
    let _serials = [];

    for (let stack in stacks) {
        if (stacks[stack].value) {
            _stacks.push(stacks[stack].value)
        }
    }

    for (let serial in serials) {
        if (serials[serial].value) {
            _serials.push(serials[serial].value)
        }
    }

    $.ajax({
        type: "POST",
        url: url,
        data: {
            "csrfmiddlewaretoken": $("input[name='csrfmiddlewaretoken']").prop("value"),
            "stacks": JSON.stringify(_stacks),
            "serials": JSON.stringify(_serials)
        },
        success: function (response) {
            let title = response.title;
            let message = response.message;
            $("#modal-header").text(title).attr("style", "color: green; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: green; text-align: center;");
            $('#message').modal("show");

            setTimeout(function () {
                $('#message').modal("hide");
            }, 2000);
        },
        error: function (response) {
            let title = response.responseJSON.title;
            let message = response.responseJSON.message;
            $("#modal-header").text(title).attr("style", "color: red; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: red; text-align: center;");
            $('#message').modal("show");

            setTimeout(function () {
                $('#message').modal("hide");
            }, 2000);
        }
    })
}

function getControllerSerials(device_id) {
    let url = "/device/controllers/serials/";

    $.ajax({
        type: "POST",
        url: url,
        data: {
            "csrfmiddlewaretoken": $("input[name='csrfmiddlewaretoken']").prop("value"),
            "device_id": device_id
        },
        success: function (response) {
            let title = response.title;
            let message = response.message;
            $("#modal-header").text(title).attr("style", "color: green; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: green; text-align: center;");
            $('#message').modal("show");

            setTimeout(function () {
                $('#message').modal("hide");
            }, 2000);

            updateDeviceMappingForm(device_id)
        },
        error: function (response) {
            let title = response.responseJSON.title;
            let message = response.responseJSON.message;
            $("#modal-header").text(title).attr("style", "color: red; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: red; text-align: center;");
            $('#message').modal("show");

            setTimeout(function () {
                $('#message').modal("hide");
            }, 2000);
        }
    })
}

function updateDeviceMappingForm(device_id) {
    let url = "/device/controllers/serials/";
    let i = 0;

    setInterval(function () {
        if (i < 10) {
            $.ajax({
                type: "GET",
                url: url,
                data: {
                    "device_id": device_id
                },
                success: function (response) {
                    let stacks = response.stacks;
                    let serials = response.serials;

                    for (let stack in stacks) {
                        let serial_id = document.getElementById("id_controller_serial_" + stack).value;

                        if (serial_id === "") {
                            console.log('Stack:', stack, 'Serial ID:', serial_id);

                            let controller_serial = stacks[stack]["controller_serial"];
                            if (controller_serial) {
                                document.getElementById("id_controller_serial_" + stack).value = controller_serial;
                            }
                        }
                    }
                    $("#modal-serials-list").empty();

                    for (let serial in serials) {
                        $("#modal-serials-list").append("<p>" + serials[serial] + "</p>");
                    }
                },
            });
            i++;
        }
    }, 500);
}
